import Headroom from "react-headroom";
import Header from "components/header";
import {
  CONTEST_ENTRY_ID_QUERY_PARAM,
  DEFAULT_AVATAR_SRC,
  REFERRER_QUERY_PARAM,
  secondaryColor,
  sparketBlack
} from "utils/constants.ts";
import React, { useEffect, useState } from "react";
import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";
import Username from "components/profile/username.tsx";
import AvatarAndBadges from "components/avatar/avatar-display/avatar-and-badges.tsx";
import MyBetItem from "components/my-bets/my-bet-item";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text.tsx";
import { Bet } from "interfaces/bet.ts";
import { Link, useParams } from "react-router-dom";
import { getRequest } from "utils/httpClient.ts";
import { useAppSelector } from "state/hooks.ts";
import { getGroupState } from "state/slices/group-slice.ts";
import { toast } from "react-toastify";
import LoadingSpinner from "components/loading-spinner.tsx";
import useQueryParams from "utils/useQueryParams.ts";
import Spinner from "react-bootstrap/Spinner";
import UsersResponse from "interfaces/users-response.ts";
import { BackButton } from "components/contests/contest-display-items/shared/buttons";
import { ContestEntryPublicView } from "interfaces/contest-entry-public-view.ts";
import BlockyLightText from "components/custom-texts/blocky-light-text.tsx";
import {
  getBetsPath,
  getContestEntryPath,
  integratedGetContestEntry,
  integratedMyBets
} from "utils/backend-path-builders.ts";
import { getIntegratedAppState, IntegratedAppState } from "state/slices/integrated-app-slice.ts";

const UserPage = () => {

  const group = useAppSelector(getGroupState);

  const integratedAppState = useAppSelector(getIntegratedAppState);

  const { id: userId } = useParams<{ id: string }>();
  const queryParams = useQueryParams();
  const contestEntryIdQueryParam: string | null = queryParams.get(CONTEST_ENTRY_ID_QUERY_PARAM);
  const referrerQueryParam: string | null = queryParams.get(REFERRER_QUERY_PARAM);

  const [bets, setBets] = useState<Bet[]>();

  const [user, setUser] = useState<UsersResponse>();
  const [contestEntry, setContestEntry] = useState<ContestEntryPublicView>();

  useEffect(() => {
    if (userId) {
      getRequest(`/v2/users/me?userId=${userId}`)
        .then(response => setUser(response))
        .catch(() => toast.error("Something went wrong."));
    }
  }, [userId]);

  useEffect(() => {
    if (integratedAppState.state === IntegratedAppState.UNDEFINED) {
      return;
    }
    if (userId && group.id) {
      if (contestEntryIdQueryParam) {

        const path = integratedAppState.state === IntegratedAppState.NOT_INTEGRATED ?
          getBetsPath(group.id, contestEntryIdQueryParam, userId) : integratedMyBets(contestEntryIdQueryParam);

        getRequest(path)
          .then((response: Bet[]) => setBets(response))
          .catch(() => toast.error("Failed to load the user's picks."));

        const path1 = integratedAppState.state === IntegratedAppState.NOT_INTEGRATED ?
          getContestEntryPath(contestEntryIdQueryParam) : integratedGetContestEntry(contestEntryIdQueryParam);

        getRequest(path1)
          .then((contestEntry: ContestEntryPublicView) => setContestEntry(contestEntry));
      } else {
        setBets([]);
      }
    }
  }, [group.id, userId, contestEntryIdQueryParam, integratedAppState.state]);

  return <div className={"d-flex flex-column"} style={{ minHeight: "100vh" }}>
    <Headroom>
      <Header />
    </Headroom>
    <div
      style={{
        backgroundColor: sparketBlack,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 10,
        position: "relative"
      }}
    >
      <BlockyBoldText style={{ color: secondaryColor, fontSize: 30 }}>
        Profile
      </BlockyBoldText>
      {referrerQueryParam && contestEntry &&
        <div style={{ position: "absolute", left: 0, top: 20 }}>
          <BackButton backUrl={`/${referrerQueryParam}?contestId=${contestEntry.contest_id}`} />
        </div>}

      {user ? <div className={"d-flex flex-column align-items-center"}>
          <Username username={user.user_name} readonly={true} />

          <AvatarAndBadges avatar={user.avatar === "" ? DEFAULT_AVATAR_SRC : user.avatar} badges={user.badges} />
        </div>
        : <div><LoadingSpinner /></div>
      }

    </div>

    {!bets ?
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "40vh"
        }}
      >
        <Spinner animation="border" />
      </div>
      :
      <div>
        {contestEntry && <div
          className="d-flex align-items-center justify-content-start flex-wrap gap-2"
          style={{
            margin: "1.2rem",
            color: "white",
          }}
        >
          <BlockyHeavyText>
            <Link to={`/contest/${contestEntry.contest_id}`} style={{ color: "white" }}>
              {contestEntry.contest_name}
            </Link>
          </BlockyHeavyText>
          <BlockyLightText style={{ fontSize: "0.8rem", }}>
            (picks appear once each pool closes)
          </BlockyLightText>
        </div>}

        {bets.map((bet, index) =>
          <MyBetItem
            readonly={true}
            onClick={() => {
            }}
            key={index}
            bet={bet}
          />)}

      </div>}
  </div>;

};

export default UserPage;